"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BuyAddonsButton;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _r10SourceLibrary = require("r10-source-library");
var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function BuyAddonsButton(_ref) {
  var showEligibleAddons = _ref.showEligibleAddons;
  var t = (0, _useTranslation.default)();
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "buy-addons-button"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    text: t('buyAddons'),
    appearance: "primary",
    onClick: showEligibleAddons
  }));
}
BuyAddonsButton.propTypes = {
  showEligibleAddons: _propTypes.default.func
};